import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { makeRequest } from "../../api";
import NoDetail from "../NoDetail";
import IndividualTigerContainer from "../../Containers/IndividualTigerImages/IndividualTigerContainer";

const TigerImages = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [tigerList, setTigerList] = useState({ species_count: {} });
  const [searchTerm, setSearchTerm] = useState(""); // New state for search input

  useEffect(() => {
    setLoading(true);
    const getImages = async () => {
      try {
        const result = await makeRequest(
          "get",
          `/api/v1/identification/identified_tiger_group/?count=${true}`
        );
        const temp = result.data;
        setLoading(false);
        setTigerList(temp);
      } catch (error) {
        setLoading(false);
        console.error("Failed to fetch new images:", error);
      }
    };

    getImages();
  }, []);

  const handleGroupClick = useCallback(
    (groupName) => {
      navigate(`${encodeURIComponent(groupName)}`);
    },
    [navigate]
  );

  const sortedSpecies = useMemo(() => {
    const entries = Object.entries(tigerList?.species_count || {});
    return entries.sort(([aKey, aCount], [bKey, bCount]) => {
      if (aKey === "null") return -1; // null always first
      if (bKey === "null") return 1;
      return bCount - aCount; // sort by count desc
    });
  }, [tigerList]);

  // Filter sortedSpecies by search term, case-insensitive
  const filteredSpecies = useMemo(() => {
    if (!searchTerm) return sortedSpecies;

    return sortedSpecies.filter(([speciesId]) => {
      const displayName = speciesId === "null" ? "Unidentified" : speciesId;
      return displayName.toLowerCase().includes(searchTerm.toLowerCase());
    });
  }, [searchTerm, sortedSpecies]);

  return (
    <div className="Setting_User">
      <div className="Setting_User_Header">
        <div>
          <span>Images</span>
        </div>
        <div className="Setting_User_Attribute">
          <div className="role_search">
            <input
              type="text"
              placeholder="Search by name"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <img src={require("../../Assets/Icons/search_icon.png")} alt="" />
          </div>
        </div>
      </div>

      {loading ? (
        <div className="Images_Table" style={{ height: "70vh" }}>
          <NoDetail loading={loading} />
        </div>
      ) : (
        <>
          <IndividualTigerContainer
            organizedData={filteredSpecies}
            handleGroupClick={handleGroupClick}
          />
        </>
      )}
    </div>
  );
};

export default TigerImages;
